import { useMemo } from 'react';
import { Product, AbsProduct, HycProduct, IgcProduct } from '@/creditflowresearch/domain/Product';
import DealsTable from '@/creditflowresearch/ui/components/deals/DealListTable/DealsTable/AbsDealsTable';
import CorporateDealsTable from '@/creditflowresearch/ui/components/deals/DealListTable/DealsTable/CorporateDealsTable';
import { useProductsContext } from '@/creditflowresearch/application/Deal/contexts/ProductsContext';

const PRODUCT_TYPE_CONFIGS = [
  {
    productTypes: [HycProduct.ABBREVIATION, IgcProduct.ABBREVIATION],
    component: CorporateDealsTable,
  },
  {
    productTypes: [AbsProduct.ABBREVIATION],
    component: DealsTable,
  },
];

const findMatchingConfig = (selectedProductIds: string[]) => {
  if (!selectedProductIds || selectedProductIds.length === 0) {
    return PRODUCT_TYPE_CONFIGS[PRODUCT_TYPE_CONFIGS.length - 1];
  }

  const selectedProductIdsSet = new Set(selectedProductIds);

  const foundConfig = PRODUCT_TYPE_CONFIGS.find((config) => {
    return config.productTypes.some((productType) => {
      const productId = Product.getId(productType);
      return productId && selectedProductIdsSet.has(productId);
    });
  });

  return foundConfig || PRODUCT_TYPE_CONFIGS[PRODUCT_TYPE_CONFIGS.length - 1];
};

const DealTables = (props) => {
  const { selectedTab } = useProductsContext();

  const matchingConfig = useMemo(() => {
    return findMatchingConfig(selectedTab?.productIds || []);
  }, [selectedTab]);

  const Component = matchingConfig?.component;
  const key = `table-${ matchingConfig?.productTypes?.join('-') || 'default' }-${ selectedTab?.id || 'default' }`;

  if (!Component) {
    return null;
  }

  return <Component key={ key } { ...props } />;
};

export default DealTables;
